module.exports = __webpack_public_path__ + "img/agency-gamification.a2603202.svg";